"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DaysSincePipe = void 0;
const core_1 = require("@angular/core");
const angular_1 = require("angular");
let DaysSincePipe = class DaysSincePipe {
    transform(value) {
        const date = (0, angular_1.isDate)(value) ? value : new Date(value);
        const dateDiff = new Date().getTime() - date.getTime();
        return Math.ceil(Math.abs(dateDiff) / (1000 * 60 * 60 * 24));
    }
};
DaysSincePipe = __decorate([
    (0, core_1.Pipe)({
        name: 'daysSince',
    })
], DaysSincePipe);
exports.DaysSincePipe = DaysSincePipe;
